export default {
  computed: {
    statusTimeline() {
      const timeline = this.document && this.document.status_timeline;
      if (!Array.isArray(timeline)) {
        return [];
      }

      return [...timeline].sort(
        (a, b) => new Date(b.changed_at) - new Date(a.changed_at)
      );
    },
  },
  methods: {
    timelineEntryLabel(entry) {
      const slug = entry.status && entry.status.slug ? entry.status.slug : "";
      const prefix = this.statusTimelineI18nPrefix || "STOCK.STATUSES.ACTION";
      const key = `${prefix}.${slug.toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : (entry.status && entry.status.name) || slug || "-";
    },
    timelineEntryColor(entry) {
      const slug = entry.status && entry.status.slug;
      const map = this.statusTimelineColorMap || {};
      return map[slug] || "grey";
    },
    formatTimelineDate(value) {
      if (!value) {
        return "-";
      }

      return new Date(value).toLocaleString();
    },
  },
};
